import { Controller } from 'react-hook-form';
import { Inputs, Label } from 'components';
import { FormTextFieldStyled } from './styled';


const formatNumberWithCommas = (value) => {
  if (!value && value !== 0) return '';
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const removeCommas = (value) => {
  if (!value) return '';
  return value.toString().replace(/,/g, '');
};


const FormTextField = ({ type, maxLength, showCharCount, useComma, isNotStartNumberZero, control, iconInlinePrefix, name, labelSize, labelFontFamily, labelColor, subLabelColor, label, required = false, subLabel, errors, ...rest }) => (
  <FormTextFieldStyled>
    <div className="box_input_item">
      <Controller
        control={control}
        name={name}
        defaultValue=""
        render={({ field: { onChange, onBlur, value } }) => (
          <>
            <div className="label_row">
              <Label.LabelForm subLabelColor={subLabelColor} labelFontFamily={labelFontFamily} labelSize={labelSize} labelColor={labelColor} label={label} required={required} subLabel={subLabel} />
              {showCharCount && maxLength && (
                <span className="char_count">{(value || '').length}/{maxLength}</span>
              )}
            </div>
            <div className="inline_prefix_container">
              {iconInlinePrefix && <span className="inline_prefix">
                {iconInlinePrefix}
              </span>
              }
              <Inputs.InputText
                {...rest}
                maxLength={maxLength}
                onBlur={onBlur}
                onChange={(e) => {
                  if (type === 'number') {
                    const rawValue = removeCommas(e.target.value);
                    const numberRegex = /^\d*$/;
                    if (numberRegex.test(rawValue)) {
                      if (maxLength && rawValue.length > maxLength) {
                        return;
                      }
                      if (isNotStartNumberZero && rawValue.length > 1 && rawValue.startsWith('0')) {
                        onChange(rawValue.replace(/^0+/, ''));
                        return;
                      }
                      if (isNotStartNumberZero && rawValue === '0') {
                        return;
                      }
                      onChange(rawValue);
                    }
                  } else {
                    onChange(e);
                  }
                }}
                value={type === 'number' && useComma ? formatNumberWithCommas(value) : value}
                errors={errors}
              />
            </div>
          </>)}
      />
    </div>
  </FormTextFieldStyled>
);

export default FormTextField;
